<template>
  <v-col class="ma-0 pa-0" cols="auto">
    <v-navigation-drawer app v-model="drawer" permanent floating clipped :width="navWidth"
      id="nav_bar">
      <v-col class="ma-0 pa-2" cols="12">
        <v-col class="ma-0 pa-0" cols="auto" id="nav_main_title" align="center">
          <v-img height="30px" width="8rem" class="ma-0 pa-0" contain
						src="@/assets/images/usen_camera_logo.png"></v-img>
        </v-col>
      </v-col>
      <v-list dense class="mt-0 pa-0" v-if="onlyAdmin == false">
				<!-- Role Main, Head -->
        <template v-if="role == 'main' || role == 'head'">
          <template v-for="item in navItems">
						<!-- 그룹라벨 생성 -->
						<template v-if="item.name == 'labelCreate'">
							<v-row class="ma-0 pa-0" align="start" :key="item.name"
								v-if="authorities.GET_STORE_LABEL"
                :class="{'nav_margin_top': exMargin}" justify="space-between">
								<v-col class="ma-0 pa-3 pt-2 pb-2 pr-1 detail_group" style="font-size:0.8rem;color:white;">
									<v-row class="ma-0 pa-0" align="center">
										<v-img max-height="1.25rem" max-width="1.25rem" class="ma-0 pa-0 mr-2"
											:src="require(`@/assets/images/${item.icon}.png`)" contain
										></v-img>
										<v-col class="ma-0 pa-0" cols="auto">
											{{ tn(item.name) }}
										</v-col>
									</v-row>
								</v-col>
								<v-col class="ma-0 pa-0" cols="auto">
									<v-btn width="35px" height="40px" class="back_clean_btn ma-0 pa-2 pl-3 pr-3" 
										elevation="0" @click="newLabelDialogVisible = true">
										<v-img max-height="1.5rem" max-width="1.25rem" class="ma-0 pa-0"
											src="@/assets/images/plus_round.png"
										></v-img>
									</v-btn>
								</v-col>
							</v-row>
						</template>
						<!-- 점포그룹 라벨 -->
						<template v-else-if="item.name == 'storeGroup'">
							<v-row class="ma-0 pa-0 nav_margin_bottom" align="start" :key="item.name"
                :class="{'nav_margin_top': exMargin && !authorities.GET_STORE_LABEL}" justify="space-between">
								<v-list-group class="ma-0 pa-0 detail_group" :key="refreshKey"
                  v-model="item.active" no-action append-icon="">
                  <template v-slot:activator>
										<!-- 그룹 라벨 목록 -->
                    <v-list-item-content align="left" class="menu_item ma-0 pa-3 pt-2 pb-2 pr-1">
                      <v-list-item-title style="font-size:0.8rem;">
                        <v-row class="ma-0 pa-0" align="center">
                          <v-img max-height="0.8rem" max-width="0.8rem" class="ma-0 pa-0 mr-1"
                            v-if="item.active"
                            src="@/assets/images/icon_bottom_arrow.png"
                          ></v-img>
                          <v-img max-height="0.8rem" max-width="0.8rem" class="ma-0 pa-0 mr-1"
                            v-if="item.active == false || item.active == undefined"
                            style="transform: rotate(-0.5turn);"
                            src="@/assets/images/icon_bottom_arrow.png"
                          ></v-img>
                          <v-img max-height="1.25rem" max-width="1.2rem" class="ma-0 pa-0 mr-2"
                            :src="require(`@/assets/images/${item.icon}.png`)" contain
                          ></v-img>
                          <v-col class="ma-0 pa-0" cols="auto">
                            {{ tn(item.name) }}
                          </v-col>
                        </v-row>
                      </v-list-item-title>
                    </v-list-item-content>
                  </template>

									<!-- 그룹 라벨 목록 내 점포그룹 목록 -->
                  <v-list-item v-for="(child, idx) in item.children" :key="child.groupId"
                    class="ma-0 pa-0" style="width:250px;">
										<template v-if="child.labelId">
											<!-- 라벨그룹 -->
											<v-row class="ma-0 pa-0" align="start" justify="space-between">
												<v-list-group class="ma-0 pa-0 detail_group" sub-group
													v-model="child.active" no-action append-icon="" prepend-icon="">
													<template v-slot:activator>
														<v-list-item-content align="left" class="menu_item ma-0 pa-3 pt-2 pb-2 pr-1">
															<v-list-item-title style="font-size:0.8rem;">
																<v-row class="ma-0 pa-0" align="center">
																	<v-img max-height="0.8rem" max-width="0.8rem" class="ma-0 pa-0 mr-1"
																		v-if="child.active"
																		src="@/assets/images/icon_bottom_arrow.png"
																	></v-img>
																	<v-img max-height="0.8rem" max-width="0.8rem" class="ma-0 pa-0 mr-1"
																		v-if="child.active == false || child.active == undefined"
																		style="transform: rotate(-0.5turn);"
																		src="@/assets/images/icon_bottom_arrow.png"
																	></v-img>
																	<v-img max-height="1.25rem" max-width="1.2rem" class="ma-0 pa-0 mr-2"
																		:src="require(`@/assets/images/${child.icon}.png`)" contain
																	></v-img>
																	<v-col class="ma-0 pa-0 ellipsis" cols="auto" style="max-width:120px;">
																		{{ child.name }}
																	</v-col>
																</v-row>
															</v-list-item-title>
														</v-list-item-content>
													</template>
													<!-- 라벨그룹 내 점포그룹 -->
													<v-list-item v-for="group in child.children" :key="group.groupId"
														class="ma-0 pa-0" style="width:250px;">
														<v-list-item-content class="menu_item ma-0 pa-3" align="left"
															@click="goPush(group.path)"
															:class="{'current_route': group.groupId == currentGroupId}">
															<v-list-item-title class="ma-0 pa-0 pl-10" style="max-width:200px;">
																<v-col class="ma-0 pa-0 ellipsis" cols="auto">
																	{{ group.name }}
																</v-col>
															</v-list-item-title>
														</v-list-item-content>
													</v-list-item>
												</v-list-group>
												<!-- 그룹라벨이름 옆 + 아이콘 -->
												<v-col class="ma-0 pa-0 pr-1" cols="auto"
													v-if="authorities.GET_STORE_LABEL">
													<v-menu offset-y>
														<template v-slot:activator="{ on, attrs }">
															<v-btn width="25px" height="25px" id="gray_btn" class="pa-2 pl-3 pr-3" 
																elevation="0" v-bind="attrs" v-on="on">
																<v-img max-height="1.5rem" max-width="1.25rem" class="ma-0 pa-0"
																	src="@/assets/images/more_btn.png"
																></v-img>
															</v-btn>
														</template>
														<v-list class="ma-0 pa-0" dense>
															<v-list-item @click="changeLabelName(child, idx)">
																<v-list-item-title align="center">{{ tn('changeLabelName') }}</v-list-item-title>
															</v-list-item>
															<v-divider id="middle_divider" class="ma-0 pa-0"></v-divider>
															<v-list-item @click="deleteLabel(child, idx)">
																<v-list-item-title align="center">{{ tn('deleteLabel') }}</v-list-item-title>
															</v-list-item>
														</v-list>
													</v-menu>
												</v-col>
											</v-row>
										</template>
										<template v-else>
											<!-- 라벨 미지정 점포그룹 -->
											<v-list-item-content class="menu_item ma-0 pa-3" align="left"
												@click="goPush(child.path)"
												:class="{'current_route': child.groupId == currentGroupId}">
												<v-list-item-title class="ma-0 pa-0 pl-7">
													<v-col class="ma-0 pa-0 ellipsis" cols="auto">
														{{ child.name }}
													</v-col>
												</v-list-item-title>
											</v-list-item-content>
										</template>
                  </v-list-item>

                </v-list-group>
								<!-- 그룹라벨 옆 + 아이콘 -->
								<v-col class="ma-0 pa-0" cols="auto"
                  v-if="authorities.ADD_STORE_GROUP">
                  <v-btn width="35px" height="40px" class="back_clean_btn ma-0 pa-2 pl-3 pr-3" 
                    elevation="0" @click="goPush(item.path)">
                    <v-img max-height="1.5rem" max-width="1.25rem" class="ma-0 pa-0"
                      src="@/assets/images/plus_round.png"
                    ></v-img>
                  </v-btn>
                </v-col>
							</v-row>
						</template>

						<!-- 매장 그룹 -->
            <!-- <template v-else-if="item.name == 'storeGroup'">
              <v-row class="ma-0 pa-0 nav_margin_bottom" align="start" :key="item.name"
                :class="{'nav_margin_top': exMargin}" justify="space-between">
                <v-list-group class="ma-0 pa-0 detail_group"
                  v-model="item.active" no-action append-icon="">
                  <template v-slot:activator>
                    <v-list-item-content align="left" class="menu_item ma-0 pa-3 pt-2 pb-2 pr-1">
                      <v-list-item-title style="font-size:0.8rem;">
                        <v-row class="ma-0 pa-0" align="center">
                          <v-img max-height="0.8rem" max-width="0.8rem" class="ma-0 pa-0 mr-1"
                            v-if="item.active"
                            src="@/assets/images/icon_bottom_arrow.png"
                          ></v-img>
                          <v-img max-height="0.8rem" max-width="0.8rem" class="ma-0 pa-0 mr-1"
                            v-if="item.active == false || item.active == undefined"
                            style="transform: rotate(-0.5turn);"
                            src="@/assets/images/icon_bottom_arrow.png"
                          ></v-img>
                          <v-img max-height="1.25rem" max-width="1.2rem" class="ma-0 pa-0 mr-2"
                            :src="require(`@/assets/images/${item.icon}.png`)" contain
                          ></v-img>
                          <v-col class="ma-0 pa-0" cols="auto">
                            {{ tn(item.name) }}
                          </v-col>
                        </v-row>
                      </v-list-item-title>
                    </v-list-item-content>
                  </template>
                  <v-list-item v-for="child in item.children" :key="child.name"
                    class="ma-0 pa-0" style="width:250px;">
                    <v-list-item-content class="menu_item ma-0 pa-3" align="left"
                      @click="goPush(child.path)"
                      :class="{'current_route': child.groupId == currentGroupId}">
                      <v-list-item-title class="ma-0 pa-0 pl-7">
                        <v-col class="ma-0 pa-0 ellipsis" cols="auto">
                          {{ child.name }}
                        </v-col>
                      </v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                </v-list-group>
                <v-col class="ma-0 pa-0" cols="auto"
                  v-if="authorities.ADD_STORE_GROUP">
                  <v-btn width="35px" height="40px" class="back_clean_btn ma-0 pa-2 pl-3 pr-3" 
                    elevation="0" @click="goPush(item.path)">
                    <v-img max-height="1.5rem" max-width="1.25rem" class="ma-0 pa-0"
                      v-if="currentRoute == item.name"
                      src="@/assets/images/plus_round_active.png"
                    ></v-img>
                    <v-img max-height="1.5rem" max-width="1.25rem" class="ma-0 pa-0"
                      v-if="currentRoute != item.name"
                      src="@/assets/images/plus_round.png"
                    ></v-img>
                  </v-btn>
                </v-col>
              </v-row>
            </template> -->
						<!-- 관리자 메뉴 -->
            <template v-else-if="item.name == 'adminPage'">
              <v-list-item class="ma-0 pa-1 pt-0 pb-0" :key="item.name"
                v-if="admin">
                <v-list-item-content align="left" class="menu_item ma-0 pa-3 pt-2 pb-2 pr-1"
                  :class="{'current_route': currentRoute == item.name}"
                  @click="goPush(item.path)">
                  <v-list-item-title style="font-size:0.8rem;">
                    <v-row class="ma-0 pa-0" align="center">
                      <v-img max-height="1.25rem" max-width="1.25rem" class="ma-0 pa-0 mr-2"
                        :src="require(`@/assets/images/${item.icon}.png`)" contain
                      ></v-img>
                      <v-col class="ma-0 pa-0" cols="auto">
                        {{ tn(item.name) }}
                      </v-col>
                    </v-row>
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </template>
						<!-- 그외 나머지 메뉴 -->
            <template v-else>
              <v-list-item class="ma-0 pa-1 pt-0 pb-0" :key="item.name">
                <v-list-item-content align="left" class="menu_item ma-0 pa-3 pt-2 pb-2 pr-1"
                  :class="{'current_route': currentRoute == item.name}"
                  @click="goPush(item.path)">
                  <v-list-item-title style="font-size:0.8rem;">
                    <v-row class="ma-0 pa-0" align="center">
                      <v-img max-height="1.25rem" max-width="1.25rem" class="ma-0 pa-0 mr-2"
                        :src="require(`@/assets/images/${item.icon}.png`)" contain
                      ></v-img>
                      <v-col class="ma-0 pa-0" cols="auto">
                        {{ tn(item.name) }}
                      </v-col>
                    </v-row>
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </template>
          </template>
        </template>

				<!-- Role Private, branch -->
        <template v-else>
          <template v-for="(item, index) in privateUserNavItems">
            <template v-if="item.name == 'adminPage'">
              <v-list-item class="ma-0 pa-1 pt-0 pb-0" :key="item.name"
                v-if="admin">
                <v-list-item-content align="left" class="menu_item ma-0 pa-3 pt-2 pb-2 pr-1"
                  @click="goTestPage"
                  :class="{'current_route': currentRoute == item.name, 
                    'nav_margin_top': index == 2}">
                  <v-list-item-title style="font-size:0.8rem;">
                    <v-row class="ma-0 pa-0" align="center">
                      <v-img max-height="1.25rem" max-width="1.25rem" class="ma-0 pa-0 mr-2"
                        :src="require(`@/assets/images/${item.icon}.png`)"
                      ></v-img>
                      <v-col class="ma-0 pa-0" cols="auto">
                        {{ tn(item.name) }}
                      </v-col>
                    </v-row>
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </template>
            <template v-else>
              <v-list-item class="ma-0 pa-1 pt-0 pb-0" :key="item.name">
                <v-list-item-content align="left" class="menu_item ma-0 pa-3 pt-2 pb-2 pr-1"
                  @click="goPush(item.path)"
                  :class="{'current_route': currentRoute == item.name, 
                    'nav_margin_top': item.name == 'privateNotification'}">
                  <v-list-item-title style="font-size:0.8rem;">
                    <v-row class="ma-0 pa-0" align="center">
                      <v-img max-height="1.25rem" max-width="1.25rem" class="ma-0 pa-0 mr-2"
                        :src="require(`@/assets/images/${item.icon}.png`)"
                      ></v-img>
                      <v-col class="ma-0 pa-0" cols="auto">
                        {{ tn(item.name) }}
                      </v-col>
                    </v-row>
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </template>
          </template>
        </template>
      </v-list>
      <v-list dense class="mt-0 pa-0" v-else>
        <v-list-item class="ma-0 pa-1 pt-0 pb-0">
          <v-list-item-content align="left" class="menu_item ma-0 pa-3 pt-2 pb-2 pr-1"
            :class="{'current_route': currentRoute == 'adminPage'}"
            @click="goPush('/admin')">
            <v-list-item-title style="font-size:0.8rem;">
              <v-row class="ma-0 pa-0" align="center">
                <v-img max-height="1.25rem" max-width="1.25rem" class="ma-0 pa-0 mr-2"
                  :src="require(`@/assets/images/icon_user.png`)"
                ></v-img>
                <v-col class="ma-0 pa-0" cols="auto">
                  {{ '관리자메뉴' }}
                </v-col>
              </v-row>
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>

      <v-col class="ma-0 pa-0 mt-5" cols="12" align="left">
        <v-divider id="middle_divider" class="ma-0 pa-0"></v-divider>
        <v-col class="ma-0 pa-2 pb-0" cols="auto"
          v-if="onlyAdmin == false">
          <v-btn width="auto" height="auto" @click.stop="serviceDrawer = !serviceDrawer"
            class="back_clean_btn ma-0 pa-2" elevation="0">
            <v-row class="ma-0 pa-0" align="center" style="color:white;">
              <v-img max-height="1.25rem" max-width="1.25rem" class="ma-0 pa-0 mr-2"
                src="@/assets/images/service_menu_white.png"></v-img>
              {{ t('service') }} 
            </v-row>
          </v-btn>
        </v-col>
        <v-col class="ma-0 pa-2" cols="12" :class="{'pb-16':$store.state.isMobile}">
          <v-menu offset-y attach bottom absolute min-width="230" :position-x="8">
            <template v-slot:activator="{ on, attrs }">
              <v-btn width="235" height="2.5rem" class="back_clean_btn ma-0 pa-0 pl-1 pr-1"
                v-bind="attrs" v-on="on" elevation="0">
                <v-row class="ma-0 pa-0" align="end">
                  <v-col class="ma-0 pa-0 pl-1 text-wrap" cols="auto" style="width:225px;"
                    align="left">
                    {{ td('welcome') + ' ' + userNickName }}
                  </v-col>
                  <v-img max-height="1rem" max-width="1rem" class="ma-0 pa-0"
                    src="@/assets/images/corner_bottom_arrow.png"></v-img>
                </v-row>
              </v-btn>
            </template>
            <v-list class="ma-0 pa-0" style="border: 1px solid white;">
              <v-list-item class="ma-0 pa-0" style="cursor: pointer; background:white;"
                @click="logout">
                <v-list-item-title id="list_font" class="ma-0 pa-0 pl-3 pr-3" 
                  align="start">
                  {{ td('logout') }}
                </v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
        </v-col>
        <v-col class="ma-0 pa-2 pt-0" cols="auto" style="width:10rem;"
          v-if="admin">
          <v-select class="ma-0 pa-1" v-model="selectedLang"
            :items="langList" dense hide-details outlined label="Language"
            dark item-text="label" item-value="value"
          ></v-select>
        </v-col>

        <v-col id="private_nav_menu" class="ma-0 pa-2 mt-5 pb-8" cols="12"
          v-if="role == 'private' || role == 'branch'">
          <!-- <v-col class="ma-0 pa-1 pt-5 pb-0" cols="12" style="font-size:0.8rem;">
            {{`加入サービス`}}
          </v-col>
          <v-col class="ma-0 pa-0 pt-4" cols="12">
            <v-row class="ma-0 pa-0" align="start" justify="start">
              <v-col class="ma-0 pa-0 mb-3" cols="4" align="center"
                v-for="(item, index) in userSubscribedService" :key="index">
                <v-row class="ma-0 pa-0" justify="center">
                  <v-img max-height="3rem" max-width="3rem" class="ma-0 pa-0"
                    :src="item.serviceLogoUrl">
                    <template v-slot:placeholder>
                      <v-row class="fill-height ma-0" align="center" justify="center">
                        <v-skeleton-loader :boilerplate="false" elevation="0" dark 
                          type="image" width="3rem" height="3rem"
                        ></v-skeleton-loader>
                      </v-row>
                    </template>  
                  </v-img>
                </v-row>
                <v-row id="info_text_small" class="ma-0 pa-0" justify="center">
                  {{item.serviceName}}
                </v-row>
              </v-col>
            </v-row>
          </v-col> -->
          <v-col class="ma-0 pa-0" cols="12">
            <v-row class="ma-0 pa-0 pl-1 pr-1 pt-15" id="info_text_small">
              <v-col class="ma-0 pa-1" cols="auto" id="info_text_left">
                {{`住所`}}:
              </v-col>
              <v-col class="ma-0 pa-1" cols="auto" id="info_text_right">
                {{userDetailData.unisCustomerAddress1}} <br> {{userDetailData.unisCustomerAddress2}} <br> {{userDetailData.unisCustomerAddress3}}
              </v-col>
            </v-row>
            <v-row class="ma-0 pa-0 pl-1 pr-1" id="info_text_small">
              <v-col class="ma-0 pa-1" cols="auto" id="info_text_left">
                {{`電話`}}:
              </v-col>
              <v-col class="ma-0 pa-1" cols="auto" id="info_text_right">
                {{userDetailData.phoneNo}}
              </v-col>
            </v-row>
            <v-row class="ma-0 pa-0 pl-1 pr-1" id="info_text_small">
              <v-col class="ma-0 pa-1" cols="auto" id="info_text_left">
                {{`管理者`}}:
              </v-col>
              <v-col class="ma-0 pa-1" cols="auto" id="info_text_right">
                {{userNickNameLong}}
              </v-col>
            </v-row>
          </v-col>
        </v-col>
      </v-col>
    </v-navigation-drawer>

    <v-navigation-drawer v-model="serviceDrawer" left app temporary dark 
			:width="this.$i18n.locale == 'en' ? 310 : 275" color="#313131" style="z-index:12;">
      <v-list class="ma-0 pa-0" id="nav_font">
				<v-list-item align="start" style="cursor: default;">
					<v-list-item-title>
						<v-row class="ma-0 pa-0" align="center" justify="end">
							<v-btn width="auto" height="auto" class="back_clean_btn ma-0 pa-0" 
								elevation="0" @click="serviceDrawer = false">
								<v-img max-height="2rem" max-width="2rem" class="ma-0 pa-0"
									src="@/assets/images/close_square.png"></v-img>
							</v-btn>
						</v-row>
					</v-list-item-title>
				</v-list-item>
				<v-list-item align="start" style="cursor: default;">
					<v-list-item-title>
						<v-row class="ma-0 pa-0" align="center">
							<v-col class="ma-0 pa-0" cols="auto">
								<strong>USEN</strong>
							</v-col>
							<v-col class="ma-0 pa-0" cols="auto" style="font-size:0.8rem;">
								<strong>{{t('service')}}</strong>
							</v-col>
						</v-row>
					</v-list-item-title>
				</v-list-item>
				<v-list-item align="start" v-for="(item, index) in userSubscribedService" :key="index" :href="item.serviceLinkUrl">
					<v-list-item-title>
						<v-row id="bottom_border" class="ma-0 pa-0 pb-2 pt-2 pl-2" align="center">
							<v-col class="ma-0 pa-0 mr-2" cols="auto">
								<v-img max-height="2rem" max-width="2rem" class="ma-0 pa-0 mr-2"
									:src="item.serviceLogoUrl"></v-img>
							</v-col>
							<v-col class="ma-0 pa-0" cols="auto">
								<v-col id="nav_title" class="ma-0 pa-0 pb-1" cols="auto">
									<img :src="item.serviceLogoTextUrl" height="1rem" style="height:0.8rem; object-fit:contain" />
								</v-col>
								<v-col class="ma-0 pa-0" cols="auto" style="font-size:0.8rem;">
									<strong>{{item.serviceName}}</strong>
								</v-col>
							</v-col>
						</v-row>
					</v-list-item-title>
				</v-list-item>
			</v-list>
    </v-navigation-drawer>
		<NewLabelDialog :dialogVisible="newLabelDialogVisible"
      @visible="newLabelDialogVisibleFunc" />
		<NameChangeDialog :dialogVisible="nameChangeDialogVisible"
      :currentId="currentGroupLabelId" :currentName="currentLabelName"
			@nameUpdate="nameUpdateFunc"
      @visible="nameChangeDialogVisibleFunc" :editType="editNameType"/>
  </v-col>
</template>

<script>
import mixin from '@/mixin';
import { Set_routes } from '@/router';
import StoreGroupDetail from '@/views/store-group/Index.vue';
import NewLabelDialog from '@/components/dialogs/NewLabelDialog.vue';
import NameChangeDialog from '@/components/dialogs/NameChangeDialog.vue';
import { logoutUserDataReset } from '@/views/login/logout';

export default {
	components: {
		NewLabelDialog, NameChangeDialog
	},
	mixins: [mixin.common],
	data: () => ({
    drawer: true,
		newLabelDialogVisible: false,
		nameChangeDialogVisible: false,
    serviceDrawer: false,
    currentRoute: '',
    currentGroupId: '',
    currentGroupLabelId: '',
		currentLabelName: '',
		editNameType: 'labelName',
    originalRoutes: Set_routes,
		navItems: [],
    privateUserNavItems: [],
    navWidth: 250,
    langList: [
			{ label: 'Japanese', value: 'jp' },
			{ label: 'Korean', value: 'ko' },
			{ label: 'English', value: 'en' },
		],
		selectedLang: 'jp',
		admin: false,
    onlyAdmin: false,
    role: '',
    userSubscribedService: [],
		userData: {},
    userDetailData: {},
    authorities: {},
    exMargin: true,
    userNickName: '',
		refreshKey: 0,
	}),
  watch: {
		$route: {
      immediate: true,
      handler(to, from) {
        // console.log(to);
        this.currentGroupId = to.query.groupId;
        this.navWidth = this.navWidthSet(to.name);
        const role = this.roleCheck(this.$store.getters.getRole);
        if(role == 'main' || role == 'head') {
          if(to.name == 'groupStoreSearch' || to.name == 'groupShareUser') {
            this.currentRoute = 'storeGroup';
          } else if(to.name == 'accountSetting' || to.name == 'authoritySetting'
            || to.name == 'branchStoreSearch' || to.name == 'branchStoreSearchResult'
            || to.name == 'notificationSetting') {
            this.currentRoute = 'accountSetting'
          } else if(to.name == 'adminPage' || to.name == 'testDeviceData' || to.name == 'testDeviceChange'
            || to.name == 'testPage') {
            this.currentRoute = 'adminPage'
          } else {
            this.currentRoute = to.name;
          }
        } else { // Role이 private, branch 유저일때
          if(to.name == 'authoritySetting' || to.name == 'notificationSetting') {
            this.currentRoute = 'privateAccountSetting';
          } else if(to.name == 'notificationDetail') {
            this.currentRoute = 'privateNotification'
          } else if(to.name == 'adminPage' || to.path.includes('test')) {
            this.currentRoute = 'adminPage'
          } else {
            this.currentRoute = to.name;
          }
        }
      }
    },
    selectedLang: async function(item) {
			await localStorage.setItem('ueyes-lang', item);
			this.$i18n.locale = item;
		},
    serviceDrawer: function(item) {
			this.$store.state.serviceNav = item;
		},
    '$store.state.serviceNav': function(item) {
      this.serviceDrawer = item;
    },
		'$store.state.userData.storeGroupLabel': {
      deep: true,
      handler(val, oldVal) {
        let index = this.navItems.findIndex(r => r.path === '/store-group/create');
        if(index !== -1) this.navItems[index].children = this.makeNavStoreGroupLabel(val);
        // v-list-group item refresh 를 위해서 그룹을 접어준다
        // this.navItems[index].active = false;
				this.refreshKey++;
      }
    },
	},
  computed: {
    mobileCheck: function() {
      if(this.$store.state.isMobile) {
        return 0;
      } else {
				return 250;
      }
    },
    userNickNameLong() {
      let unisCustomerName = this.$store.state.userData.userDetail.unisCustomerName;
      if(unisCustomerName == undefined) {
        return unisCustomerName;
      } else {
        if(unisCustomerName.length > 18) {
          return unisCustomerName.substring(0,18) + '...';
        } else {
          return unisCustomerName;
        }
      }
    }
  },
	created() {
    this.role = this.roleCheck(this.$store.getters.getRole);
    this.authorities = this.$store.getters.getAuthorities;
    this.admin = this.$store.state.userData.user.admin;
    this.onlyAdmin = this.$store.state.userData.user.onlyAdmin;
    this.userNickName = this.$store.state.userData.userDetail.unisCustomerName;
    this.navWidth = this.navWidthSet(this.$route.name);
		this.navItems = this.originalRoutes.slice(0, 8);// 8이후 nav에서 다른 router를 숨겨야 한다. 9 admin까지 포함
    this.checkAuthNavItem();
    this.privateUserNavItems = this.makePrivateNavItems(this.originalRoutes);
		let lIndex = this.navItems.findIndex(r => r.path === '/store-group/create');
		if(lIndex != -1) this.navItems[lIndex].children = this.makeNavStoreGroupLabel(this.$store.getters.getStoreGroupLabel);
    // let index = this.navItems.findIndex(r => r.path === '/store-group/create');
    // if(index != -1) this.navItems[index].children = this.makeNavChildren(this.$store.getters.getStoreGroupList);
    this.userDetailData = this.$store.getters.getUserDetail;
		this.userData = this.$store.state.userData.user;
    // console.log(this.userDetailData);
    // console.log(this.userData);
  },
  mounted() {
		this.selectedLang = this.$i18n.locale;
    this.getUserService();
	},
	methods: {
    td(t) {
      return this.$t("lang.dashboard." + t);
    },
    navWidthSet(routerName) {
      if(this.$store.state.isMobile && window.location.href.includes('mobile')) {
        return 0;
      } else {
        if(routerName == 'storeSearchDetail' || routerName == 'storeCCTV' 
          || routerName == 'otherStoreAnalyze' || routerName == 'videoPlayerPage' 
          || routerName == 'storeMapEdit' || routerName == 'splitFullScreen'
          || routerName == 'storeAnalyze' || routerName == 'privateSplitFullScreen'
          || routerName == 'videoDownloadSetting') {
          return 0;
        } else {
					const path = window.location.href;
					if(path.includes('mobile')) return 0;
					else return 250;
        }
      }
    },
		newLabelDialogVisibleFunc(visible) {
			this.newLabelDialogVisible = visible;
		},
		nameChangeDialogVisibleFunc(visible) {
      this.nameChangeDialogVisible = visible;
    },
		nameUpdateFunc(item) {
			this.fetchStoreGroupLabel();
		},
    checkAuthNavItem() {
      let authorities = this.$store.getters.getAuthorities;
      if(authorities.GET_DASHBOARD == false) {
        let index = this.navItems.findIndex(r => r.name === 'dashboard');
        this.navItems.splice(index, 1);
      }
      if(authorities.GET_TOTAL_STORES == false) {
        let index = this.navItems.findIndex(r => r.name === 'allStore');
        this.navItems.splice(index, 1);
      }
      if(authorities.SEARCH_STORE == false) {
        let index = this.navItems.findIndex(r => r.name === 'storeSearch');
        this.navItems.splice(index, 1);
      }
      if(authorities.GET_DASHBOARD == false && authorities.GET_TOTAL_STORES == false
        && authorities.SEARCH_STORE == false) {
        this.exMargin = false;
      }
      if(authorities.GET_RECORDING_SUB_BRANCH == false) {
        let index = this.navItems.findIndex(r => r.name === 'storeGroup');
        this.navItems.splice(index, 1);
      }
    },
		makeNavStoreGroupLabel(storeGroupLabelData) {
			let children = [];
      storeGroupLabelData.forEach((item) => {
				if(item.labelName) {
					children.push({
						name: item.labelName,
						labelId: item.id,
						children: this.makeLabelChildren(item.storeGroups),
						unisCustomerCd: item.unisCustomerCd,
						icon: 'label_icon',
					});
				} else {
					item.storeGroups.forEach((group) => {
						children.push({
							name: group.groupName,
							groupId: group.id,
							umid: group.umid,
							path: `/store-group/detail?groupId=${group.id}`,
							component: StoreGroupDetail,
							props: true
						});
					})
				}
      });
      return children;
		},
		makeLabelChildren(storeGroups) {
			let children = [];
			if(storeGroups == undefined) return [];
      storeGroups.forEach((item) => {
        children.push({
          name: item.groupName,
          path: `/store-group/detail?groupId=${item.id}`,
          groupId: item.id,
					storeGroupLabelId: item.storeGroupLabelId,
					umid: item.umid,
          component: StoreGroupDetail,
          props: true
        });
      });
      return children;
		},
    makeNavChildren(storeGroupList) {
      let children = [];
      storeGroupList.forEach((item) => {
        children.push({
          name: item.groupName,
          path: `/store-group/detail?groupId=${item.id}`,
          groupId: item.id,
          component: StoreGroupDetail,
          props: true
        });
      });
      return children;
    },
		goPush(path) {
      this.pushRoute(path, {});
    },
    goTestPage() {
			this.pushRoute('/test', {});
		},
    makePrivateNavItems(navItems) {
			const privateUserAnalytics = this.$store.getters.getPrivateUserAnalytics;
      let privateNav = [];
      navItems.forEach((item) => {
        if(this.authorities.GET_RECORDING && item.name == 'privateStoreCCTV') privateNav.push(item); 
        if(this.authorities.GET_OWN_STORE && item.name == 'privateStoreAnalytics') {
					if(privateUserAnalytics == true) privateNav.push(item); 
				}
        if(item.name == 'privateOtherStoreAnalytics' || item.name == 'privateNotification' 
          || item.name == 'privateAccountSetting') {
          privateNav.push(item);
        }
      });
      navItems.forEach((item) => {
        if(item.name == 'adminPage') privateNav.push(item);
      });
      return privateNav;
    },
    async logout() {
			let router_data = {
				fromLogout: true
			};
			// this.$store.state.user = null;
			// this.$store.state.menus = [];

			await this.$dialog.confirm({
        title: this.td('logout'),
				text: this.td('askLogout'),
				actions: {
					false: { color: 'white', text: this.t('cancel'),},
					true: {
						color: 'white', text: this.t('confirm'),
						handle: () => {
              logoutUserDataReset();
							this.$router.push({name: 'login', params: router_data});
						}
					}
				}
			});
		},
    async getUserService() {
			let date = new Date(this.userData.expired);
      let param = {};
      await this.networkController.getUserSubscribedService(param, date.getTime(), this.userData.refreshToken)
      .then(async (res) => {
        // console.log(res.data);
        this.userSubscribedService = res.data;
        this.$store.commit('setUserSubscribedService', res.data);
      }).catch(error => { });
    },
		changeLabelName(label, index) {
			this.currentGroupLabelId = label.labelId;
			this.currentLabelName = label.name;
			this.nameChangeDialogVisible = true;
		},
		deleteLabel(label, index) {
			this.$vloading.show();
			let param = {};
      this.networkController.deleteStoreGroupLabel(param, label.labelId)
      .then(async (res) => {
        this.fetchStoreGroupLabel();
				this.showToastMessage(this.tmb('requestSuccess'));
      }).catch(error => {
				this.$vloading.hide();
			});
		},
		fetchStoreGroupLabel() {
			const params = {};
			this.networkController.getStoreGroupLabel(params).then(async (res) => {
				console.log('%cFetch Store Group Label\n', "color:#008DD0;", res.data);
				this.$store.commit('setStoreGroupLabel', res.data);
				this.$vloading.hide();
			}).catch(error => {
				this.$vloading.hide();
			});
		},
	}
}
</script>

<style lang="scss" scoped>
#nav_bar {
	background-color: #1D202C;
  font-family: note-sans-jp-bold;
  overflow-y: auto;
  z-index: 11;
	max-height: 100% !important;
}
#nav_main_title {
  font-family: note-sans-jp-light;
  font-weight: 100;
	color: white;
	font-size: 1.3rem;
}
.current_route {
  color: white;
  background-color: rgb(65 68 76);
  border-radius: 3px;
}
.nav_margin_bottom {
	margin-bottom: 1.5rem !important;
}
.nav_margin_top {
	margin-top: 1.5rem !important;
}
.back_clean_btn {
	background-color: transparent !important;
	min-width: 1rem !important;
	color: white;
}
.v-list {
  background: #171921;
}
::v-deep {
	.detail_group {
		width: 210px;
		&> .v-list-item {
			padding-left: 4px;
			padding-right: 4px;
		}
	}
	.v-list-item__title{
		color: white;
    font-family: note-sans-jp-medium, Helvetica Neue, Helvetica, PingFang SC, Hiragino Sans GB,
      Microsoft YaHei, SimSun, sans-serif;
	}
	.v-input__slot {
		padding-right: 2px !important;
	}
	.v-input__append-inner {
		margin-top: 16px !important;
		padding-left: 0px !important;
	}
	.v-navigation-drawer {
		&::-webkit-scrollbar {
      width: 3px;
    }
    &::-webkit-scrollbar-thumb {
      background-color: white;
    }
    &::-webkit-scrollbar-track {
      background-color: #4A4A4A;
    }
		&__content {
			&::-webkit-scrollbar {
				width: 3px;
			}
			&::-webkit-scrollbar-thumb {
				background-color: white;
			}
			&::-webkit-scrollbar-track {
				background-color: #4A4A4A;
			}
		}
	}
	.v-list-group__items {
    overflow-y: auto;
    overflow-x: hidden;
    max-height: 400px;
    width: 250px;
		&::-webkit-scrollbar {
      width: 3px;
    }
    &::-webkit-scrollbar-thumb {
      background-color: white;
    }
    &::-webkit-scrollbar-track {
      background-color: #4A4A4A;
    }
	}
}
.menu_item {
  cursor: pointer;
	color: white;
  // &:hover {
  //   background-color: #1D202C;
  //   border-radius: 8px;
  // }
}
#middle_divider {
	background-color: #4C4C4C;
}
#private_nav_menu {
  color: white;
  // position: absolute;
  // bottom: 0;
  // left: 0;
}
#info_text_small {
  font-size: 0.7rem;
}
#info_text_right {
  text-align: left;
  // width: 9.5rem;
}
#info_text_left{
  text-align: left;
  width: 3rem;
}
#list_font {
	font-size: 0.8rem;
  color: black;
	font-family: note-sans-jp-bold;
}
#nav_font {
	font-family: note-sans-jp-medium;
}
#nav_title {
	font-size: 0.9rem;
}
#bottom_border {
	border-bottom: 1px solid #505050;
}
#gray_btn {
	margin-top: 8px;
	min-width: 0.5rem;
	background-color: #5c5c5c;
	border-radius: 6px;
}
</style>